import type {IProduto} from "@models/produtos/produto.js";
import React from "react";
import {DefaultConsumerPesquisaAutoProps, DefaultPesquisaAuto} from "@shared/specialComponents/DefaultPesquisaAuto.tsx";
import {IGetProdutoFilters} from "@components/produtos/dto/IProdutosFilter.ts";
import __produto_endpoints from "@components/produtos/endpoints/__produto_endpoints.ts";

interface ProdutoPesquisaProps extends DefaultConsumerPesquisaAutoProps<IProduto, IGetProdutoFilters> {

}

export const ProdutoPesquisa: React.FC<ProdutoPesquisaProps> = (props) => {
    const handleItemSelected = (item: IProduto | undefined) => {
        if (props.onItemSelected) {
            props.onItemSelected(item);
        }
    };

    const formataProduto = (produto: IProduto) => `${produto.erpId} - ${produto.nome}`;

    return (
        <DefaultPesquisaAuto<IProduto, IGetProdutoFilters>
            endpoint={__produto_endpoints['v2']['get-produtos']} // Pass the API function
            searchField={'nome'}
            itemToString={formataProduto}   // Pass the formatting function
            onItemSelected={handleItemSelected} // Pass the selection handler
            display={{
                name: "Produto"
            }}
            {...props}
        />
    );
};